export type ModuleName = "dill/exercises"
export const MODULE_NAME: ModuleName = "dill/exercises"
